import moment from 'moment';

// CLAUDE.md (reactjs-extranet) — interceptor axios em Service.js já faz unwrap de error.response.data;
// no catch, err É o objeto data, então acessamos err.message direto (com fallback ternário).
export const extrairMensagemErro = (err, fallback) => {
  if (!err) return fallback || 'Erro inesperado';
  if (err.message) return err.message;
  if (typeof err === 'string') return err;
  return fallback || 'Erro inesperado';
};

export const formatBRL = (valor) => {
  const numero = valor != null ? Number(valor) : 0;
  if (Number.isNaN(numero)) return 'R$ 0,00';
  return numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
};

export const formatDataBR = (data) => {
  if (!data) return '-';
  const m = moment(data);
  if (!m.isValid()) return '-';
  return m.format('DD/MM/YYYY');
};

export const formatDataHoraBR = (data) => {
  if (!data) return '-';
  const m = moment(data);
  if (!m.isValid()) return '-';
  return m.format('DD/MM/YYYY HH:mm');
};

export const STATUS_SESSAO_LABEL = {
  R: 'Em revisão',
  L: 'Lançada',
  D: 'Descartada',
};

export const BANCO_ORIGEM_LABEL = {
  104: 'Caixa Econômica Federal',
  341: 'Itaú',
  237: 'Bradesco',
  '033': 'Santander',
};

export const ITENS_POR_PAGINA = 50;
